import * as actions from './actions';

const assignEmptyClassObject = () => (
    {
        classroomGroups: [],
        name: '',
        studentsProfileId: [],
        teachersName: [],
        teachersProfileId: []
    }
);

const initialState = {
    addGroupIsActive: false,
    addGroupIsSuccess: false,
    addGroupInProgress: false,
    addGroupAddedGroup: {},
    classroomDetail: assignEmptyClassObject(),
    isLoadingEditClassDetail: false,
    isDownloadingSignInCards: false,
    editClassGroupIsVisible: false,
    selectedGroup:
    {
        classroomId: 0,
        courseId: 0,
        courseTitle: '',
        id: 0,
        isDefault: false,
        isTaskVisible: false,
        name: 'Default Group',
        studentIds: []
    },
    isSelectedGroupDefault: false,
    showRenameGroupModal: false,
    showRenameGroupConfirmationModal: false,
    isRenameGroupInProgress: false,
    showRenameGroupConfirmationBeforeSubmit: false,
    showDeleteGroupConfirmation: false,
    showDeleteGroupConfirmationBeforeSubmit: false,
    showDeleteNonEmptyGroupConfirmationModal: false,
    isSavingClass: false,
    isUserOperationModalOpen: false,
    disableConfirmationButtons: false,
    isSignInCardDownloaded: false,
    downloadingTeachersIds: new Set(),
    isUpdateSuccessful: true,
    editClassValidationMessage: '',
    isDeletingGroupInProgress: false,
    refreshEditClass: false,
    operationType: '',
    refreshTeacherList: false,
    selectedTeachers: [],
    changeCourseAssignedTasks: [],
    changeCourseIsActive: false,
    changeCourseTaskActionType: false,
    countryYearGroups: []
};

function editClassReducer(state = initialState, action) {
    switch (action.type) {
    case actions.GET_CLASS_REQUEST: {
        return { ...state, isLoadingEditClassDetail: action.isLoadingEditClassDetail };
    }

    case actions.GET_CLASS_SUCCESS: {
        return {
            ...state,
            classroomDetail: action.data,
            isLoadingEditClassDetail: action.isLoadingEditClassDetail
        };
    }

    case actions.GET_CLASS_FAILURE: {
        return { ...state, isLoadingEditClassDetail: action.isLoadingEditClassDetail };
    }

    case actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST: {
        return { ...state, isDownloadingSignInCards: action.isDownloadingSignInCards };
    }

    case actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS: {
        return { ...state, isDownloadingSignInCards: action.isDownloadingSignInCards };
    }

    case actions.DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE: {
        return { ...state, isDownloadingSignInCards: action.isDownloadingSignInCards };
    }

    case actions.RENAME_GROUP_REQUEST: {
        return { ...state, isRenameGroupInProgress: action.isRenameGroupInProgress };
    }

    case actions.RENAME_GROUP_SUCCESS: {
        return {
            ...state,
            isRenameGroupInProgress: action.isRenameGroupInProgress,
            showRenameGroupConfirmationModal: action.showRenameGroupConfirmationModal,
            showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit
        };
    }

    case actions.RENAME_GROUP_FAILURE: {
        return {
            ...state,
            isRenameGroupInProgress: action.isRenameGroupInProgress,
            showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit

        };
    }

    case actions.SHOW_EDIT_CLASS_GROUP: {
        return { ...state, editClassGroupIsVisible: true, selectedGroup: action.selectedGroup };
    }

    case actions.HIDE_EDIT_CLASS_GROUP: {
        return { ...state, editClassGroupIsVisible: false, selectedGroup: null };
    }

    case actions.CLOSE_EDIT_GROUP: {
        return { ...state, editClassGroupIsVisible: false };
    }

    case actions.SHOW_RENAME_GROUP_MODAL: {
        return {
            ...state,
            showRenameGroupModal: action.showRenameGroupModal
        };
    }

    case actions.HIDE_RENAME_GROUP_MODAL: {
        return { ...state, showRenameGroupModal: action.showRenameGroupModal
        };
    }

    case actions.OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT: {
        return {
            ...state,
            showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit,
            refreshEditClass: action.refreshEditClass
        };
    }
    case actions.CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT: {
        return { ...state,
            showRenameGroupConfirmationBeforeSubmit: action.showRenameGroupConfirmationBeforeSubmit
        };
    }

    case actions.CLOSE_RENAME_GROUP_CONFIRMATION: {
        return {
            ...state,
            showRenameGroupConfirmationModal: action.showRenameGroupConfirmationModal,
            showRenameGroupModal: action.showRenameGroupModal,
            editClassGroupIsVisible: action.editClassGroupIsVisible,
            refreshEditClass: action.refreshEditClass,
            selectedGroup: action.selectedGroup
        };
    }

    case actions.MODIFIED_CLASS_SAVE_REQUEST: {
        return { ...state,
            isSavingClass: action.isSavingClass,
            isUpdateSuccessful: action.isUpdateSuccessful
        };
    }

    case actions.MODIFIED_CLASS_SAVE_SUCCESS: {
        return { ...state,
            isSavingClass: action.isSavingClass,
            isUpdateSuccessful: action.isUpdateSuccessful
        };
    }

    case actions.MODIFIED_CLASS_SAVE_FAILURE: {
        return { ...state,
            isSavingClass: action.isSavingClass,
            editClassValidationMessage: action.editClassValidationMessage,
            isUpdateSuccessful: action.isUpdateSuccessful
        };
    }

    case actions.OPEN_UNASSIGN_TEACHERS_MODAL: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType };
    }
    case actions.CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL: {
        return { ...state, refreshTeacherList: action.refreshTeacherList, selectedTeachers: action.selectedTeachers };
    }

    case actions.UNASSIGN_TEACHER_REQUEST: {
        return { ...state,
            disableConfirmationButtons: action.disableConfirmationButtons,
            selectedTeachers: [] };
    }
    case actions.UNASSIGN_TEACHER_SUCCESS: {
        return {
            ...state,
            isUserOperationModalOpen: action.isUserOperationModalOpen,
            disableConfirmationButtons: action.disableConfirmationButtons,
            selectedTeachers: []
        };
    }
    case actions.UNASSIGN_TEACHER_FAILURE: {
        return { ...state, disableConfirmationButtons: action.disableConfirmationButtons };
    }
    case actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST: {
        return { ...state, downloadingTeachersIds: action.downloadingTeachersIds };
    }
    case actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS: {
        return { ...state, downloadingTeachersIds: action.downloadingTeachersIds };
    }
    case actions.PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE: {
        return { ...state, downloadingTeachersIds: action.downloadingTeachersIds };
    }

    case actions.CLOSE_CLASS_VALIDATION_MODAL: {
        return { ...state, isUpdateSuccessful: action.isUpdateSuccessful };
    }
    case actions.DELETE_GROUP_REQUEST:
    {
        return {
            ...state,
            isDeletingGroupInProgress: action.isDeletingGroupInProgress,
            refreshEditClass: action.refreshEditClass
        };
    }
    case actions.DELETE_GROUP_SUCCESS: {
        return {
            ...state,
            isDeletingGroupInProgress: action.isDeletingGroupInProgress,
            showDeleteGroupConfirmationBeforeSubmit: action.showDeleteGroupConfirmationBeforeSubmit,
            showDeleteGroupConfirmation: action.showDeleteGroupConfirmation
        };
    }
    case actions.DELETE_GROUP_FAILURE: {
        return {
            ...state,
            isDeletingGroupInProgress: action.isDeletingGroupInProgress,
            refreshEditClass: action.refreshEditClass,
            showDeleteGroupConfirmationBeforeSubmit: action.showDeleteGroupConfirmationBeforeSubmit
        };
    }
    case actions.OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT:
    case actions.CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT: {
        return {
            ...state,
            showDeleteGroupConfirmationBeforeSubmit: action.showDeleteGroupConfirmationBeforeSubmit
        };
    }
    case actions.OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION:
    case actions.CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION: {
        return {
            ...state,
            showDeleteNonEmptyGroupConfirmationModal: action.showDeleteNonEmptyGroupConfirmationModal
        };
    }
    case actions.CLOSE_DELETE_GROUP_CONFIRMATION: {
        return {
            ...state,
            refreshEditClass: action.refreshEditClass,
            editClassGroupIsVisible: action.editClassGroupIsVisible,
            showDeleteGroupConfirmation: action.showDeleteGroupConfirmation
        };
    }
    case actions.OPEN_CHANGE_COURSE: {
        return {
            ...state,
            changeCourseIsActive: true,
            changeCourseClassroomId: action.classroomId,
            changeCourseGroupId: action.groupId,
            changeCourseActivitiesIsActive: false,
            changeCourseAssignedTasks: [],
            changeCourseTaskActionType: ''
        };
    }

    case actions.CLOSE_CHANGE_COURSE: {
        return {
            ...state,
            changeCourseIsActive: false,
            isChangingCourseSuccess: false,
            editClassGroupIsVisible: false,
            refreshEditClass: true
        };
    }

    case actions.BACK_TO_CHANGE_COURSE: {
        return {
            ...state,
            changeCourseActivitiesIsActive: false,
            changeCourseIsActive: true,
            isChangingCourseSuccess: false,
            editClassGroupIsVisible: false,
            changeCourseAssignedTasks: [],
            changeCourseTaskActionType: ''
        };
    }

    case actions.CHANGE_COURSE_SUCCESS: {
        const changeCourseActivitiesIsActive = action.data.assignedTasksId.length > 0;
        return {
            ...state,
            isChangingCourseSuccess: !changeCourseActivitiesIsActive,
            isChangingCourseInProgress: false,
            editClassGroupIsVisible: true,
            assignedCourseId: action.assignedCourseId,
            assignedUpfCourseId: action.assignedUpfCourseId,
            assignedNewCourseId: action.assignedNewCourseId,
            changeCourseClassroomId: action.classroomId,
            changeCourseGroupId: action.groupId,
            changeCourseSubmittedFields: action.submittedFields,
            changeCourseAssignedTasks: action.data.assignedTasksId,
            changeCourseActivitiesIsActive
        };
    }
    case actions.CHANGE_COURSE_REQUEST: {
        return {
            ...state,
            isChangingCourseSuccess: false,
            isChangingCourseInProgress: true,
            refreshEditClass: false
        };
    }

    case actions.CHANGE_COURSE_FAILURE: {
        return {
            ...state,
            isChangingCourseSuccess: false,
            isChangingCourseInProgress: false,
            refreshEditClass: false
        };
    }

    case actions.CHANGE_COURSE_CARRY_OVER_REQUEST: {
        return {
            ...state,
            isChangingCourseCarryOverSuccess: false,
            isChangingCourseCarryOverInProgress: true,
            refreshEditClass: false,
            changeCourseTaskActionType: action.taskActionType
        };
    }

    case actions.CHANGE_COURSE_CARRY_OVER_SUCCESS: {
        return {
            ...state,
            changeCourseActivitiesIsActive: false,
            isChangingCourseSuccess: true,
            isChangingCourseCarryOverSuccess: true,
            isChangingCourseCarryOverInProgress: false,
            refreshEditClass: true,
            editClassGroupIsVisible: true
        };
    }

    case actions.CHANGE_COURSE_CARRY_OVER_FAILURE: {
        return {
            ...state,
            isChangingCourseCarryOverSuccess: false,
            isChangingCourseCarryOverInProgress: false,
            refreshEditClass: false
        };
    }

    case actions.OPEN_ADD_GROUP: {
        return {
            ...state,
            addGroupIsActive: true
        };
    }

    case actions.CLOSE_ADD_GROUP: {
        return {
            ...state,
            addGroupIsActive: false,
            addGroupInProgress: false,
            addGroupIsSuccess: false,
            addGroupExceedGroupError: false
        };
    }

    case actions.ADD_GROUP_REQUEST: {
        return {
            ...state,
            addGroupInProgress: true,
            addGroupIsSuccess: false,
            refreshEditClass: false
        };
    }

    case actions.ADD_GROUP_SUCCESS: {
        return {
            ...state,
            addGroupInProgress: false,
            addGroupIsSuccess: true,
            refreshEditClass: true,
            addGroupAddedGroup: action.data
        };
    }

    case actions.ADD_GROUP_FAILURE: {
        return {
            ...state,
            addGroupInProgress: false,
            addGroupIsSuccess: false,
            addGroupExceedGroupError: action.addGroupErrorCode === 'MaxGroupInClassExceeded'
        };
    }

    case actions.HANDLE_COUNTRY_DROPDOWN_CHANGES: {
        return {
            ...state,
            fetchingYeargroups: true,
            fetchedYeargroups: false
        };
    }

    case actions.GET_YEARGROUPS_BY_COUNTRY_SUCCESS: {
        return {
            ...state,
            fetchingYeargroups: false,
            fetchedYeargroups: true,
            countryYearGroups: action.data
        };
    }

    case actions.GET_YEARGROUPS_BY_COUNTRY_FAILURE: {
        return {
            ...state,
            fetchingYeargroups: false,
            fetchedYeargroups: false
        };
    }

    default:
        return { ...state };
    }
}

export default editClassReducer;



// WEBPACK FOOTER //
// ./app/containers/edit-class/reducer.js